module.exports = __webpack_public_path__ + "static/security-labels-8c5dc9240190aceb920c796f90839eaf.png";